<div class="dist">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="error" class="dist__error">{{ error }}</div>

  <mat-card class="dist__card">
    <div class="dist__head">
      <h2 class="dist__title"><mat-icon>pie_chart</mat-icon> Distributions</h2>
      <div class="dist__headactions">
        <button mat-stroked-button (click)="viewRuns()">
          <mat-icon>summarize</mat-icon> View generated runs
        </button>
        <button mat-flat-button color="primary" (click)="onAdd()">
          <mat-icon>add</mat-icon> Add new distribution
        </button>
      </div>
    </div>

    <p class="dist__muted">Recurring monthly distribution schedules. Each schedule runs its
      day-ranges automatically; generated reports are available under Reports.</p>

    <table mat-table [dataSource]="schedules" class="dist__table" *ngIf="schedules.length; else empty">
      <ng-container matColumnDef="ranges">
        <th mat-header-cell *matHeaderCellDef>Distributions</th>
        <td mat-cell *matCellDef="let s">{{ s.rangesDisplay }}</td>
      </ng-container>
      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef>Created by</th>
        <td mat-cell *matCellDef="let s">{{ s.createdBy || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="starts">
        <th mat-header-cell *matHeaderCellDef>Starts</th>
        <td mat-cell *matCellDef="let s">{{ monthYear(s.startPeriod) }}</td>
      </ng-container>
      <ng-container matColumnDef="ends">
        <th mat-header-cell *matHeaderCellDef>Ends</th>
        <td mat-cell *matCellDef="let s">{{ monthYear(s.endPeriod) }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let s">
          <span class="chip chip--{{ s.status }}">{{ statusLabel(s.status) }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let s" class="dist__rowactions">
          <button mat-icon-button color="primary" matTooltip="Edit distributions" (click)="onEdit(s)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Delete" (click)="onDelete(s)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>

    <ng-template #empty>
      <p class="dist__muted" *ngIf="!loading">No distribution schedules yet. Click
        <strong>Add new distribution</strong> to create one.</p>
    </ng-template>
  </mat-card>
</div>
